/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetAllPaymentsRequest } from '../../models/get-all-payments-request';
import { PaymentResponseModel } from '../../models/payment-response-model';

export interface PostApiPaymentV1$Json$Params {

/**
 * Optional Impersonation User header
 */
  'X-Impersonated-User'?: string;
      body?: GetAllPaymentsRequest
}

export function postApiPaymentV1$Json(http: HttpClient, rootUrl: string, params?: PostApiPaymentV1$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<PaymentResponseModel>> {
  const rb = new RequestBuilder(rootUrl, postApiPaymentV1$Json.PATH, 'post');
  if (params) {
    rb.header('X-Impersonated-User', params['X-Impersonated-User'], {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PaymentResponseModel>;
    })
  );
}

postApiPaymentV1$Json.PATH = '/private/v1/payments';
